import { Component, computed, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';
import { SenseiIdDirective } from '@examdojo/browser/sensei-id';
import { MatTooltipTruncateDirective } from '@examdojo/core/mat-tooltip-truncate';
import { UserUIModel } from '@examdojo/models/user';
import { ProfileAvatarComponent } from '@examdojo/user';
import { injectNavSegment, navSegment } from '../nav-segment';

@Component({
  selector: 'dojo-sidebar-profile-link',
  standalone: true,
  imports: [RouterLink, MatTooltip, MatTooltipTruncateDirective, ProfileAvatarComponent, SenseiIdDirective],
  templateUrl: './sidebar-profile-link.component.html',
  styleUrl: './sidebar-profile-link.component.scss',
  host: { class: 'block' },
})
export class SidebarProfileLinkComponent {
  readonly user = input.required<UserUIModel>();
  readonly settingsRoute = input.required<string>();
  /**
   * Further segments that keep the link lit. The student's rail points it at
   * the profile page, from which settings is reached; a settings page is still
   * the signed-in learner, so it stays selected there.
   */
  readonly activeSegments = input<readonly string[]>([]);
  /** Matches `.sidebar-link-image` (30px) by default; the student shell's rail uses 40. */
  readonly avatarSize = input<number>(30);
  readonly clicked = output<void>();

  private readonly segment = injectNavSegment();

  readonly isActive = computed(
    () => navSegment(this.settingsRoute()) === this.segment() || this.activeSegments().includes(this.segment()),
  );

  onClick() {
    this.clicked.emit();
  }
}
